import { RecentlyViewed } from '@theme/recently-viewed-products';

class RecentlyViewedSection extends HTMLElement {
  connectedCallback() {
    this.loadProducts();
  }

  async loadProducts() {
    const productIds = RecentlyViewed.getProducts()
      .filter((id) => id !== this.dataset.currentProductId)
      .slice(0, Number(this.dataset.limit || 4));

    if (!productIds.length) {
      if (window.Shopify?.designMode) return;

      this.hidden = true;
      return;
    }

    const url = new URL(this.dataset.searchUrl || '/search', window.location.origin);
    url.searchParams.set('q', productIds.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('section_id', this.dataset.sectionId || '');

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Server returned ${response.status}`);

      const html = await response.text();
      const section = new DOMParser().parseFromString(html, 'text/html').querySelector('recently-viewed-section');
      const products = section?.querySelector('[data-recently-viewed-products]');

      if (products?.getAttribute('data-has-recently-viewed') !== 'true') {
        this.hidden = true;
        return;
      }

      this.innerHTML = section.innerHTML;
      this.hidden = false;
    } catch (error) {
      console.error('Recently viewed products error:', error);
      this.hidden = true;
    }
  }
}

if (!customElements.get('recently-viewed-section')) {
  customElements.define('recently-viewed-section', RecentlyViewedSection);
}
